/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getCustomerAlerts } from "../fn/alerts/get-customer-alerts";
import { GetCustomerAlerts$Params } from "../fn/alerts/get-customer-alerts";
import { getDevicesForSubscriptionFromGrafana } from "../fn/alerts/get-devices-for-subscription-from-grafana";
import { GetDevicesForSubscriptionFromGrafana$Params } from "../fn/alerts/get-devices-for-subscription-from-grafana";
import { getSubscriptionAlerts } from "../fn/alerts/get-subscription-alerts";
import { GetSubscriptionAlerts$Params } from "../fn/alerts/get-subscription-alerts";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class AlertsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomerAlerts()` */
  static readonly GetCustomerAlertsPath = "/dashboard/alerts/customer";

  /**
   * Get Customer Alerts.
   *
   * Retrieve grafana alerts that are firing/active for a customer.
   *
   * Args:
   *     current_user: The current user
   *
   * Returns:
   *     Alert object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerAlerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAlerts$Response(
    params?: GetCustomerAlerts$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<any>>> {
    const obs = getCustomerAlerts(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Customer Alerts.
   *
   * Retrieve grafana alerts that are firing/active for a customer.
   *
   * Args:
   *     current_user: The current user
   *
   * Returns:
   *     Alert object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerAlerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAlerts(params?: GetCustomerAlerts$Params, context?: HttpContext): Promise<Array<any>> {
    const resp = this.getCustomerAlerts$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<any>>): Array<any> => r.body);
  }

  /** Path part for operation `getSubscriptionAlerts()` */
  static readonly GetSubscriptionAlertsPath = "/dashboard/alerts/{subscription_id}";

  /**
   * Get Subscription Alerts.
   *
   * Retrieve grafana alerts that are firing/active for a subscription.
   *
   * Args:
   *     subscription_id: Subscription id to query.
   *     current_user: The current user
   *     db: Database handle
   *
   * Returns:
   *     Alert object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionAlerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionAlerts$Response(
    params: GetSubscriptionAlerts$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<any>>> {
    const obs = getSubscriptionAlerts(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Subscription Alerts.
   *
   * Retrieve grafana alerts that are firing/active for a subscription.
   *
   * Args:
   *     subscription_id: Subscription id to query.
   *     current_user: The current user
   *     db: Database handle
   *
   * Returns:
   *     Alert object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionAlerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionAlerts(params: GetSubscriptionAlerts$Params, context?: HttpContext): Promise<Array<any>> {
    const resp = this.getSubscriptionAlerts$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<any>>): Array<any> => r.body);
  }

  /** Path part for operation `getDevicesForSubscriptionFromGrafana()` */
  static readonly GetDevicesForSubscriptionFromGrafanaPath = "/dashboard/alerts/{subscription_id}/devices";

  /**
   * Get Devices For Subscription From Grafana.
   *
   * Retrieve devices for a subscription from Grafana.
   *
   * NOTE: This is a temporary solution. We should use IMS/CNAAS or something else to retrieve or replicate the devices.
   *
   * Args:
   *     subscription_id: Subscription id to query.
   *     current_user: The current user
   *     db: Database handle
   *
   * Returns:
   *     Devices list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevicesForSubscriptionFromGrafana()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesForSubscriptionFromGrafana$Response(
    params: GetDevicesForSubscriptionFromGrafana$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<any>>> {
    const obs = getDevicesForSubscriptionFromGrafana(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Devices For Subscription From Grafana.
   *
   * Retrieve devices for a subscription from Grafana.
   *
   * NOTE: This is a temporary solution. We should use IMS/CNAAS or something else to retrieve or replicate the devices.
   *
   * Args:
   *     subscription_id: Subscription id to query.
   *     current_user: The current user
   *     db: Database handle
   *
   * Returns:
   *     Devices list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevicesForSubscriptionFromGrafana$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevicesForSubscriptionFromGrafana(
    params: GetDevicesForSubscriptionFromGrafana$Params,
    context?: HttpContext,
  ): Promise<Array<any>> {
    const resp = this.getDevicesForSubscriptionFromGrafana$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<any>>): Array<any> => r.body);
  }
}
